import SkeletonBox from './SkeletonBox';
import Header from '../header/Header';

const ProductDetailsSkeleton = ({ imageCount = 4, showHeader = true }) => (
  <>
    {showHeader && <Header />}

    {/* Mobile skeleton */}
    <div className="lg:hidden">
      <SkeletonBox width="100%" height="320px" className="rounded-none" />

      <div className="mx-5 mt-4">
        <SkeletonBox width="75%" height="22px" className="rounded mb-2" />

        <div className="flex items-center gap-2 mt-3">
          <SkeletonBox width="20px" height="20px" className="rounded-full" />
          <SkeletonBox width="130px" height="14px" className="rounded" />
        </div>

        <div className="flex items-center justify-between mt-4 mb-1">
          <SkeletonBox width="150px" height="32px" className="rounded" />
          <SkeletonBox width="80px" height="44px" className="rounded-lg" />
        </div>

        <div className="mt-4">
          <SkeletonBox width="100%" height="80px" className="rounded-lg" />
        </div>

        <hr className="my-4 border-gray-100" />

        <SkeletonBox width="70%" height="16px" className="rounded mb-3" />
        <SkeletonBox width="100%" height="52px" className="rounded-lg mb-4" />
        <div className="grid grid-cols-3 gap-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonBox key={i} width="100%" height="48px" className="rounded-2xl" />
          ))}
        </div>

        <hr className="my-4 border-gray-100" />

        <SkeletonBox width="180px" height="16px" className="rounded mb-4" />
        <div className="grid grid-cols-2 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <SkeletonBox key={i} width="100%" height="76px" className="rounded-xl" />
          ))}
        </div>

        <SkeletonBox width="100%" height="220px" className="rounded-xl mt-6 mb-4" />
      </div>

      <div className="fixed bottom-24 left-3 right-3 bg-white border border-gray-100 rounded-xl px-5 py-4 flex items-center justify-between gap-3">
        <div className="flex flex-col gap-1">
          <SkeletonBox width="120px" height="20px" className="rounded" />
          <SkeletonBox width="80px" height="12px" className="rounded" />
        </div>
        <SkeletonBox width="130px" height="48px" className="rounded-lg" />
      </div>
    </div>

    {/* Desktop skeleton */}
    <div className="hidden lg:flex justify-between items-start gap-8 mx-10 pt-10">
      <main className="w-1/2">
        <div className="flex justify-between items-start gap-5">
          <aside className="grid gap-2">
            {Array.from({ length: imageCount }).map((_, index) => (
              <SkeletonBox key={index} width="94px" height="94px" className="rounded" />
            ))}
          </aside>
          <div className="flex-1 bg-[#F2F2F2] rounded-2xl h-[363px] xl:h-auto xl:aspect-square flex justify-center items-center">
            <SkeletonBox width="100%" height="100%" className="rounded-2xl" />
          </div>
        </div>

        <div className="hidden xl:grid mt-8">
          <SkeletonBox width="200px" height="24px" className="mb-4" />
          <SkeletonBox width="100%" height="60px" />
        </div>
      </main>

      <aside className="w-1/2">
        <SkeletonBox width="70%" height="24px" className="rounded mb-3" />
        <SkeletonBox width="40%" height="14px" className="rounded mb-4" />

        <div className="flex items-center justify-between mb-4">
          <div className="flex flex-col gap-2">
            <SkeletonBox width="160px" height="32px" className="rounded" />
            <SkeletonBox width="100px" height="14px" className="rounded" />
          </div>
          <div className="flex items-center gap-2">
            <SkeletonBox width="140px" height="48px" className="rounded-lg" />
            <SkeletonBox width="80px" height="48px" className="rounded-lg" />
          </div>
        </div>

        <SkeletonBox width="100%" height="80px" className="rounded-lg mb-4" />

        <SkeletonBox width="60%" height="16px" className="rounded mb-3" />
        <SkeletonBox width="100%" height="52px" className="rounded-lg mb-3" />
        <div className="grid grid-cols-3 gap-3 mb-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonBox key={i} width="100%" height="48px" className="rounded-2xl" />
          ))}
        </div>

        <SkeletonBox width="180px" height="16px" className="rounded mb-4" />
        <div className="grid grid-cols-2 gap-4 mb-6">
          {Array.from({ length: 4 }).map((_, i) => (
            <SkeletonBox key={i} width="100%" height="76px" className="rounded-xl" />
          ))}
        </div>

        <SkeletonBox width="100%" height="240px" className="rounded-xl" />
      </aside>
    </div>

    <section className="mb-24 mx-5 mt-14">
      <div className="flex justify-between items-center mb-6">
        <SkeletonBox width="180px" height="24px" />
        <SkeletonBox width="80px" height="20px" />
      </div>
      <div className="grid grid-flow-col space-x-4 w-full overflow-x-scroll scrollbar-hide">
        {Array.from({ length: 3 }).map((_, index) => (
          <SkeletonBox key={index} width="218px" height="300px" className="rounded-2xl" />
        ))}
      </div>
    </section>
  </>
);

export default ProductDetailsSkeleton;
